import { defineMessages } from 'react-intl';

export default defineMessages({
    coverages: {
        id: 'rewrite.common.directives.templates.ml-rewrite-sticky-header.Coverages',
        defaultMessage: 'Coverages'
    },
    umbrellaCoverage: {
        id: 'rewrite.common.directives.templates.ml-rewrite-sticky-header.Umbrella Coverage',
        defaultMessage: 'Umbrella Coverage'
    },
    coverageTotal: {
        id: 'rewrite.common.directives.templates.ml-rewrite-sticky-header.Coverage Total',
        defaultMessage: 'Coverage Total'
    },
    amount: {
        id: 'rewrite.common.directives.templates.ml-rewrite-sticky-header.x/year',
        defaultMessage: '{totalPremium}/year'
    },
    amountPerMonth: {
        id: 'rewrite.common.directives.templates.ml-rewrite-sticky-header-pa.x/month',
        defaultMessage: '{totalPremium}/month'
    },
    helpRenter: {
        id: 'rewrite.common.directives.templates.ml-rewrite-sticky-header.Help-Renter',
        defaultMessage: 'Estimated Replacement cost is the estimated amount of money it would take to repair or replace your personal property with items of like, kind and quality. This amount can be changed to reflect the amount of coverage that you need.'
    },
    helpCondo: {
        id: 'rewrite.common.directives.templates.ml-rewrite-sticky-header.Help-Condo',
        defaultMessage: 'Estimated Replacement cost is the estimated amount of money it would take to repair, replace or rebuild your Condo unit with materials of like, kind and quality.  These estimates are based upon information given to us from a professional construction valuating service.  Many items attached as part of your condo unit may be your insurance responsibility as per the Condo Association By-Laws.  Some Associations require unit owners to pay for interior construction materials such as drywall, paint, cabinetry, countertops and interior doors.  It is important that you understand these requirements.  If you are required to pay for such items, then you may need to increase your Replacement Cost coverage.  This is the estimated amount needed to rebuild your unit if the association requires you to provide coverage.'
    },
    helpHome: {
        id: 'rewrite.common.directives.templates.ml-rewrite-sticky-header.Help-Home',
        defaultMessage: 'Estimated Replacement cost is the estimated amount of money it would take to repair, replace or rebuild your home with materials of like, kind and quality.  These estimates are based upon information given to us from a professional construction valuating service.  This is our recommended amount necessary to rebuild your home, however, you can choose to change the amount of coverage for comparison.  Your mortgage company may require you to maintain a specific level of replacement cost coverage on your policy.'
    },
    replacementCostContents: {
        id: 'rewrite.common.directives.templates.ml-rewrite-sticky-header.Your estimated replacement cost for the contents is $xxx,xxx.',
        defaultMessage: 'Your estimated replacement cost for the contents is {replacementCost}.'
    },
    replacementCostDwelling: {
        id: 'rewrite.common.directives.templates.ml-rewrite-sticky-header.Your estimated replacement cost for the dwelling is $xxx,xxx.',
        defaultMessage: 'Your estimated replacement cost for the dwelling is {replacementCost}.'
    },
    premium: {
        id: 'rewrite.common.directives.templates.ml-rewrite-sticky-header-pa.PREMIUM',
        defaultMessage: 'PREMIUM'
    },
    vehicleTotal: {
        id: 'rewrite.common.directives.templates.ml-rewrite-sticky-header-pa.Vehicle Total',
        defaultMessage: 'Vehicle Total'
    },
});